<div [formGroup]="formGroup" class="mt-2">
  <wl-payment-method-selection
    formControlName="paymentType"
    [availablePaymentMethod]="paymentOptions"
    [selected]="selectedPaymentMethod"
  >
  </wl-payment-method-selection>
</div>
